module.exports = __webpack_public_path__ + "static/media/message.938b2852.mp3";